<template>
  <div class="tw-w-60 tw-bg-gray-800 tw-text-gray-300 tw-border-r tw-border-gray-700">
    <nav class="tw-p-4">
      <h2 class="tw-text-xl tw-font-bold tw-mb-4">Navigation</h2>
      <ul class="tw-space-y-2">
        <li>
          <button @click="clientExplorerStore.deselectEntity(); clientExplorerStore.setView(CLIENT_EXPLORER_VIEWS.portfolio)"
                  :class="['tw-flex tw-items-center tw-w-full tw-p-2 tw-rounded-md tw-transition-colors', 
                           clientExplorerStore.currentView === CLIENT_EXPLORER_VIEWS.portfolio ? 'tw-bg-gray-700 tw-text-white' : 'tw-hover:bg-gray-700']">
            <i class="fas fa-landmark tw-mr-3 tw-text-blue-400"></i>
            Portfolios
          </button>
          <ul class="tw-ml-6 tw-mt-2 tw-space-y-1">
            <li v-for="(view, label) in {'generic_portfolio': 'Generic', 'model_portfolio': 'Model', 'benchmark_portfolio': 'Benchmark'}" :key="view">
              <button @click="clientExplorerStore.deselectEntity(); clientExplorerStore.setView(CLIENT_EXPLORER_VIEWS[view])"
                      :class="['tw-w-full tw-p-1 tw-rounded-md tw-transition-colors', 
                               clientExplorerStore.currentView === CLIENT_EXPLORER_VIEWS[view] ? 'tw-bg-gray-700 tw-text-white' : 'tw-hover:bg-gray-700']">
                {{ label }}
              </button>
            </li>
          </ul>
        </li>
        <li v-for="(item, index) in menuItems" :key="index">
          <button @click="clientExplorerStore.deselectEntity(); clientExplorerStore.setView(item.view)"
                  :class="['tw-flex tw-items-center tw-w-full tw-p-2 tw-rounded-md tw-transition-colors', 
                           clientExplorerStore.currentView === item.view ? 'tw-bg-gray-700 tw-text-white' : 'tw-hover:bg-gray-700']">
            <i :class="['fas tw-mr-3 tw-text-blue-400', item.icon]"></i>
            {{ item.label }}
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { CLIENT_EXPLORER_VIEWS } from '@frontend/ui/stores/clientExplorerStore';

export default {
  name: "client-explorer-sidebar",
  inject: ['getClientExplorerStore'],
  computed: {
    clientExplorerStore() {
      return this.getClientExplorerStore();
    }
  },
  data() {
    return {
      CLIENT_EXPLORER_VIEWS,
      menuItems: [
        { label: 'Prospects', icon: 'fa-user-plus', view: CLIENT_EXPLORER_VIEWS.prospect },
        { label: 'Clients', icon: 'fa-user', view: CLIENT_EXPLORER_VIEWS.client },
        { label: 'Groups', icon: 'fa-users', view: CLIENT_EXPLORER_VIEWS.group },
        { label: 'Legal Entities', icon: 'fa-briefcase', view: CLIENT_EXPLORER_VIEWS.legal_entity },
        { label: 'Accounts', icon: 'fa-piggy-bank', view: CLIENT_EXPLORER_VIEWS.account },
      ]
    };
  },
};
</script>
